import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Store } from "@ngrx/store";
import { CheckboxWrapComponent } from "src/app/shared/components/ui/checkbox-wrap.component";
import { DataElement } from "src/app/shared/models/common";
import { DrProfile, DrProfilePref } from "src/app/shared/models/order.model";
import { techIssuesList } from "src/app/shared/ngrx/ngrx-selectors";
import { AppState } from "src/app/shared/redux/store";

@Component({
  selector: "edit-profile-auto-approve",
  templateUrl: "./edit-profile-auto-approve.component.html",
  styleUrls: ["./edit-profile-auto-approve.component.scss"],
  standalone: true,
  imports: [CommonModule, CheckboxWrapComponent, FormsModule],
})
export class EditProfileAutoApproveComponent {
  @Input() profile: DrProfile;

  options: DataElement[] = [];

  constructor(private readonly store: Store) {}

  ngOnInit(): void {
    this.options = this.store.selectSignal(techIssuesList)();

    this.options.forEach((o) => {
      let pref = this.profile.pref.find(
        (p) => p.prefType == "AUTO_APPROVE" && p.techIssue?.id == o.id
      );
      o.selected = pref != null;
    });
  }

  save() {
    this.options.forEach((opt) => {
      let pref = this.profile.pref.find(
        (p) => p.prefType == "AUTO_APPROVE" && p.techIssue?.id == opt.id
      );

      if (opt.selected) {
        if (!pref) {
          let newPref = new DrProfilePref();
          newPref.prefType = "AUTO_APPROVE";
          newPref.techIssue = opt;
          this.profile.pref.push(newPref);
        }
      } else if (pref) {
        this.profile.pref.splice(this.profile.pref.indexOf(pref), 1);
      }
    });
  }
}
